import { IconButton, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { useGetPatientAddressQuery } from "src/api/services/addressApi";
import UpdateAddressModal from "../Modals/UpdateAddressModal";
import { useManageModal } from "src/hooks/useManageModal";
import Edit from "@mui/icons-material/Edit";
import { PatientProfile } from "src/api/types";
import AddAddressModal from "../AddAddressModal";
import { Add } from "@mui/icons-material";

interface Props {
  patient: PatientProfile;
}

const ShippingAddress = ({ patient }: Props) => {
  const [open, { handleClose, handleOpen }] = useManageModal();
  const [openAdd, { handleClose: handleCloseAdd, handleOpen: handleOpenAdd }] =
    useManageModal();
  const { data: shippingAddress } = useGetPatientAddressQuery(patient.id);

  const isLead = useMemo(() => patient.status === "Lead", [patient.status]);

  const deliveryAddress = useMemo(() => {
    if (shippingAddress == null) return null;

    return `${shippingAddress.address_line1}${
      shippingAddress.address_line2
        ? "," + " " + shippingAddress.address_line2
        : ""
    }, ${shippingAddress.city}, ${shippingAddress.state} ${
      shippingAddress.zip_code
    }`;
  }, [shippingAddress]);

  return (
    <>
      <Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          height={34}
        >
          <Typography fontWeight={700}>Shipping</Typography>

          {isLead && shippingAddress == null ? (
            <IconButton size="small" onClick={handleOpenAdd}>
              <Add />
            </IconButton>
          ) : (
            <IconButton size="small" onClick={handleOpen}>
              <Edit />
            </IconButton>
          )}
        </Stack>
        <Typography>{`Delivery address: ${deliveryAddress}`}</Typography>
      </Stack>
      {isLead && shippingAddress == null ? (
        <AddAddressModal
          open={openAdd}
          onClose={handleCloseAdd}
          patientId={patient.id}
        />
      ) : null}
      {shippingAddress ? (
        <UpdateAddressModal
          open={open}
          onClose={handleClose}
          address={shippingAddress}
        />
      ) : null}
    </>
  );
};

export default ShippingAddress;
